<script setup>
import Popup from './popup.vue';
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
import { deviceStore } from './../stores/deviceStore'

const store = deviceStore();
</script>

<script>
export default {
  components: {
      Popup,
   },
  data: () => ({
    publishingpopupshow: false,
    initialContext:"",
    viewport: "",
    meetingInfo:{},
    form: null,
    ribbon: null,
    config: []
  }),
  mounted() {
  },
  beforeDestroy() {
    if (this.form) {
      this.form.destructor();
    }
    if (this.ribbon) {
      this.ribbon.destructor();
    }
  },
  computed:{
  },
  methods: {
    createDeepLink: function() {
        console.log("got initial context",this.initialContext);
        var client = window.botStore.getClientByViewPort(this.viewport); 
        let GrantPath = JSON.parse(client.CurrentContext);
        let GrantPE = GrantPath.GrantPE;
        let InitialContext = document.getElementById('initialContext').value;
        let LocationContext = JSON.parse(client.LocationContext);
        console.log("location context",LocationContext);
        let signedURL = LocationContext.origin + '/DeviceManager/index.html';
        console.log("location context signedurl",signedURL);
        //let signedURL = '/DeviceManager/index.html';

        $.ajax({
        type:"POST",
        url:"/BotServices/bot/getSignedUrl",
        data: JSON.stringify({"Role":'visitor',"Component":client.ClientRight,"URL":signedURL,"InitialContext":InitialContext}),
        dataType:"json",
        contentType:"application/json",
        success: function(res) {
            console.log("Got HTTP Response signedurl");
            console.log(res);
            // document.getElementById("meetshorturl").innerHTML= res.ShortURL;   
            //document.getElementById("deeplinkdiv").style.display = "";
            }
        });
        //window.DevMgr.setMeeting(document.getElementById('initialContext').value);
        this.publishingpopupshow = false;
    },
    openPublishingPopup : function(client,viewport,store) {
        console.log("====show pop up publish===="+this.publishingpopupshow);
        this.publishingpopupshow = true;
        this.viewport = viewport;
        this.ribbon = new dhx.Ribbon(this.$refs.publishingribbon, {
        css: "dhx_widget--bg_white"
      });
         
    this.showRibbon();

    this.form = new dhx.Form(this.$refs.publishingform, {
      css: "dhx_widget--bg_white",
      width: "100%",
      rows: [
        {
            padding: 40,
            title: "Properties",
            rows:[
                    {
                    name: "Role",
                    type: "select",
                    label: "Role",
                    labelPosition: "left",
                    labelWidth: "50",
                    value: "",
                    required: true,
                    options: [
                        {
                            value: "",
                            content: ""
                        },
                        {
                            value: "agent",
                            content: "agent"
                        },
                        {
                            value: "owner",
                            content: "owner"
                        },
                        {
                            value: "admin",
                            content: "admin"
                        },
                        {
                            value: "visitor",
                            content: "visitor"
                        },
                        {
                            value: "user",
                            content: "user"
                        },
                        {
                            value: "holder",
                            content: "holder"
                        }
                    ]
                },
                {
                    name: "TTL",
                    type: "checkbox",
                    label:"TTL",
                    labelWidth: "50",
                    labelPosition: "left",
                    text: "",
                    value: false,
                },
                {
                type: "input",
                label: "UserName",
                labelPosition: "left",
                labelWidth: "50",
                name: "username",
                icon: "dxi-magnify",
                placeholder: "Email or Phone",
                },
                {
                type: "input",
                label: "Name",
                labelPosition: "left",
                labelWidth: "50",
                name: "deeplinkcustomname",
                icon: "dxi-magnify",
                placeholder: "",
                },
                {
                type: "input",
                label: "Initial Context",
                labelPosition: "left",
                labelWidth: "50",
                name: "initialContext",
                icon: "dxi-magnify",
                placeholder: "{}",
                hidden: true
                },
            ]
        },
        {
            padding: 40,
            title: "On Load Configuration",
            rows: [
            {
                name: "openFlag",
                type: "checkbox",
                label: "Open On Load",
                labelWidth: "110",
                text: "",
                value: false,
            },
            {
                name: "onLoadComponent",
                type: "select",
                label: "OnLoad Component",
                labelPosition: "left",
                labelWidth: "110",
                value: "",
                required: true,
                options: [
                    {
                        value: "",
                        content: ""
                    },
                    {
                        value: "Main",
                        content: "Main"
                    },
                    {
                        value: "Contacts",
                        content: "Contacts"
                    },
                    {
                        value: "Inbox",
                        content: "Inbox"
                    },
                    {
                        value: "Attachments",
                        content: "Attachments"
                    },
                    {
                        value: "Alert",
                        content: "Alert"
                    }
                ]
            }    
           ]
        },
        {
            align: "end",
            cols: [
                {
                    type: "button",
                    text: "Create",
                    id: "Create",
                    size: "medium",
                    view: "flat",
                    color: "primary",
                    padding: "2px"
                },
                {
                    type: "button",
                    text: "Save",
                    id: "Save",
                    size: "medium",
                    view: "flat",
                    color: "primary",
                    padding: "2px"
                },

            ]

        },
      ],
    });
    
    

    var formSettingsAlert =  new dhx.Form("form-configure-alert", {
        css: "dhx_widget--bg_white",
        width: "100%",
        rows: [
            {
                type: "input",
                label: "Header Buttons",
                labelPosition: "left",
                labelWidth: 120,
                name: "HeaderButtons",
                icon: "dxi-magnify",
                placeholder: "Email or Phone",
                },
                {
                type: "input",
                label: "Footer Buttons",
                labelPosition: "left",
                labelWidth: 120,
                name: "FooterButtons",
                icon: "dxi-magnify",
                placeholder: "",
                },
                {
                type: "input",
                label: "Context",
                labelWidth: 120,
                labelPosition: "left",
                name: "Context",
                icon: "dxi-magnify",
                placeholder: "{}",
                hidden: false
                },
                {
                type: "input",
                label: "Body",
                labelPosition: "left",
                labelWidth: 120,
                name: "body",
                icon: "dxi-magnify",
                placeholder: "HTML Content",
                },
                {
                type: "input",
                label: "Sound File",
                labelPosition: "left",
                labelWidth: 120,
                name: "soundFile",
                icon: "dxi-magnify",
                placeholder: "",
                },
                {
                    align: "end",
                    cols: [
                        {
                            id: "apply-button-configure-alert",
                            type: "button",
                            text: "Get"
                        }
                    ]

                },
                {
                    type: "spacer"
                }
            ]
        });

        formSettingsAlert.events.on("ButtonClick", function(id,e){
            console.log("<b>onClick event Family</b> button("+id+") was clicked with "+formSettingsAlert.getValue());
            let HeaderButtons = formSettingsAlert.getValue()["HeaderButtons"];
            let FooterButtons = formSettingsAlert.getValue()["FooterButtons"];
            let Context = formSettingsAlert.getValue()["Context"];
            let body = formSettingsAlert.getValue()["body"];
            let soundFile = formSettingsAlert.getValue()["soundFile"];

            /*$.ajax({
            type:"POST",
            url:"/BotServices/bot/setTermination",
            data: {"ComponentID":Component,"CssLink":CssLink,"MediaType":MediaType,"Template":Template,"URL":Url},
            dataType:"json",
            success: function(data) {
                console.log("Got HTTP Response configure termination");
                console.log(data);
                }
            });*/
        });

    var formSettingsGetChildTermination =  new dhx.Form("form-settings-get-child-termination", {
        css: "dhx_widget--bg_white dhx_layout-cell-header",
        width: "100%",
        rows: [
                {
                type: "input",
                label: "ComponentID",
                name: "ChildComponent",
                id: "ChildComponent",
                value: '',
                labelWidth: "120",
                labelPosition: "left",
                readOnly : false
                },
                {
                    align: "end",
                    cols: [
        {
                            id: "apply-button-configure-termination",
                            type: "button",
                            text: "Get"
                        }
                    ]

                },
                {
                    type: "spacer"
                }
            ]
        });

        var formSettingsGetTermination =  new dhx.Form("form-settings-get-termination", {
        css: "dhx_widget--bg_white dhx_layout-cell-header",
        width: "100%",
        rows: [
                {
                type: "input",
                label: "ComponentID",
                name: "Component",
                id: "Component",
                value: '',
                labelWidth: "120",
                labelPosition: "left",
                readOnly : false
                },
                {
                    align: "end",
                    cols: [
        {
                            id: "apply-button-configure-termination",
                            type: "button",
                            text: "Get"
                        }
                    ]

                },
                {
                    type: "spacer"
                }
            ]
        });

      //  formSettingsGetTermination.events.on("ButtonClick", function(id,e){
        //console.log("<b>onClick event Family</b> button("+id+") was clicked with "+formSettingsGetTermination.getValue());
        var client = window.botStore.getClientByViewPort(this.viewport); 
        let Component = client.ClientRight;

        $.ajax({
        type:"POST",
        url:"/BotServices/bot/getTermination",
        data: {"ComponentID":Component},
        dataType:"json",
        success: function(data) {
            console.log("Got HTTP Response get termination");
            //document.getElementById("form-settings-configure-termination").style.display = "";
            console.log(data);
            let terminationObj = {};

            if(data.InitialContext && data.InitialContext.Termination) {
                terminationObj = data.InitialContext.Termination;
            } else {
                terminationObj = {"CssLink":"","MediaType":"","Template":"","URL":""};
            }


            let formSettingsConfigureTermination = new dhx.Form("form-settings-configure-termination", {
                css: "dhx_widget--bg_white dhx_widget--bordered",
                padding: 40,
                width: "100%",
                rows: [
                        {
                        type: "hidden",
                        label: "ComponentID",
                        name: "ComponentID",
                        id: "ComponentID",
                        value: Component,
                        labelWidth: "60",
                        labelPosition: "left",
                        readOnly : false
                        },
                        {
                        type: "input",
                        label: "CssLink",
                        name: "CssLink",
                        id: "CssLink",
                        value: terminationObj.CssLink,
                        labelWidth: "60",
                        labelPosition: "left",
                        readOnly : false
                        },
                        {
                        type: "input",
                        label: "MediaType",
                        name: "MediaType",
                        value: terminationObj.MediaType,
                        labelWidth: "60",
                        labelPosition: "left"
                        },
                        {
                        type: "input",
                        label: "Template",
                        name: "Template",
                        value: terminationObj.Template,
                        labelWidth: "60",
                        labelPosition: "left"
                        },
                        {
                        type: "input",
                        label: "Url",
                        name: "Url",
                        value: terminationObj.URL,
                        labelWidth: "60",
                        labelPosition: "left"
                        },
                        {
                            align: "end",
                            cols: [
                                {
                                    id: "apply-button-configure-termination",
                                    type: "button",
                                    text: "Set"
                                }
                            ]

                        }
                    ]
                });

                formSettingsConfigureTermination.events.on("ButtonClick", function(id,e){
                    console.log("<b>onClick event Family</b> button("+id+") was clicked with "+formSettingsConfigureTermination.getValue()["Url"]);
                    let CssLink = formSettingsConfigureTermination.getValue()["CssLink"];
                    let MediaType = formSettingsConfigureTermination.getValue()["MediaType"];
                    let Template = formSettingsConfigureTermination.getValue()["Template"];
                    let Url = formSettingsConfigureTermination.getValue()["Url"];
                    let ComponentID = formSettingsConfigureTermination.getValue()["ComponentID"];

                    $.ajax({
                    type:"POST",
                    url:"/BotServices/bot/setTermination",
                    data: {"ComponentID":Component,"CssLink":CssLink,"MediaType":MediaType,"Template":Template,"URL":Url},
                    dataType:"json",
                    success: function(data) {
                        console.log("Got HTTP Response configure termination");
                        console.log(data);
                        }
                    });
                });

            //document.getElementById("output-configure-termination").innerHTML = JSON.stringify(data.Item);
            }
        });
   // });
   
//formSettingsGetChildTermination.events.on("ButtonClick", function(id,e){
  //  console.log("<b>onClick event Family</b> button("+id+") was clicked with "+formSettingsGetChildTermination.getValue());
    //let Component = formSettingsGetChildTermination.getValue()["ChildComponent"];

    $.ajax({
      type:"POST",
      url:"/BotServices/bot/getTermination",
      data: {"ComponentID":Component},
      dataType:"json",
      success: function(data) {
          console.log("Got HTTP Response get termination");
          //document.getElementById("form-settings-configure-sub-termination").style.display = "";
          console.log(data);
          let terminationObj = {};let rowObj = [];

          let scoreoptionVal = {};
          scoreoptionVal.value = "";
          scoreoptionVal.content = "";
          rowObj.push(scoreoptionVal);

          if(data.InitialContext && data.InitialContext.ChildTerminations) {
            terminationObj = data.InitialContext.ChildTerminations;
            if(data.InitialContext.ChildTerminations.length > 0) {
               for(var index in data.InitialContext.ChildTerminations) {
                   let resVal = {};
                   resVal.value = data.InitialContext.ChildTerminations[index];
                   resVal.content = data.InitialContext.ChildTerminations[index].DisplayName;
                   rowObj.push(resVal);
                }
            }
          } else {
            terminationObj = {"CssLink":"","MediaType":"","Template":"","URL":""};
          }


          var formSettingsConfigureSubTermination =  new dhx.Form("form-settings-configure-sub-termination", {
            css: "dhx_widget--bg_white",
            width: "100%",
            rows: [
                  {
                  name: "ChildTerminations",
                  id: "ChildTerminations",
                  type: "select",
                  label: "Child Terminations",
                  labelWidth: "120",
                  labelPosition: "left",
                  value: "",
                  options: rowObj
                  },
                  {
                      align: "end",
                      padding: "2px",
                      cols: [
                          {
                              id: "apply-button-configure-sub-edit-termination",
                              type: "button",
                              text: "Edit"
                          },
                          {
                              id: "apply-button-configure-sub-add-termination",
                              type: "button",
                              text: "Add",
                              padding: "0px 10px"
                          },
                          {
                              id: "apply-button-configure-sub-view-termination",
                              type: "button",
                              text: "View",
                              padding: "0px 10px"
                          }                      ]

                  },
                  {
                      type: "spacer"
                  }
              ]
          });

            formSettingsConfigureSubTermination.events.on("ButtonClick", function(id,e){
                console.log("<b>onClick event Family</b> button("+id+") was clicked with "+formSettingsConfigureSubTermination.getValue()["Url"]);
                let ChildTerminations = formSettingsConfigureSubTermination.getValue()["ChildTerminations"];
                console.log("Got Child terminations value",ChildTerminations);
                let terminationObj = {};
                document.getElementById("form-settings-configure-child-termination").style.display = "";
                if(id == "apply-button-configure-sub-edit-termination") {
                  terminationObj = ChildTerminations;
                  terminationObj.Action = "Update";
                } else if(id == "apply-button-configure-sub-view-termination") {
                  terminationObj = ChildTerminations;
                  terminationObj.Action = "View";
                } else {
                  terminationObj = {"DisplayName":"","CssLink":"","MediaType":"","Template":"","URL":""};
                  terminationObj.Action = "Add";
                }

                let formSettingsConfigureChildTermination = new dhx.Form("form-settings-configure-child-termination", {
                    css: "dhx_widget--bg_white",
                    width: "100%",
                    rows: [
                          {
                            type: "hidden",
                            label: "ComponentID",
                            name: "ChildComponentID",
                            id: "ChildComponentID",
                            value: Component,
                            labelWidth: "120",
                            labelPosition: "left",
                            readOnly : false
                          },
                          {
                            type: "hidden",
                            label: "Action",
                            name: "Action",
                            id: "Action",
                            value: terminationObj.Action,
                            labelWidth: "120",
                            labelPosition: "left",
                            readOnly : false
                          },
                          {
                            type: "input",
                            label: "DisplayName",
                            name: "ComponentDisplayName",
                            id: "ComponentDisplayName",
                            value: terminationObj.DisplayName,
                            labelWidth: "120",
                            labelPosition: "left",
                            readOnly : false
                          },
                          {
                            type: "input",
                            label: "CssLink",
                            name: "CssLink",
                            id: "CssLink",
                            value: terminationObj.CssLink,
                            labelWidth: "120",
                            labelPosition: "left",
                            readOnly : false
                          },
                          {
                            type: "input",
                            label: "MediaType",
                            name: "MediaType",
                            value: terminationObj.MediaType,
                            labelWidth: "120",
                            labelPosition: "left"
                          },
                          {
                            type: "input",
                            label: "Template",
                            name: "Template",
                            value: terminationObj.Template,
                            labelWidth: "120",
                            labelPosition: "left"
                          },
                          {
                            type: "input",
                            label: "Child Url",
                            name: "Url",
                            value: terminationObj.URL,
                            labelWidth: "120",
                            labelPosition: "left"
                          },
                          {
                              align: "end",
                              cols: [
                                  {
                                      id: "apply-button-configure-termination",
                                      type: "button",
                                      text: "Set"
                                  },
                                  ,
                                  {
                                      id: "apply-button-configure-sub-remove-termination",
                                      type: "button",
                                      text: "Remove",
                                      padding: "0px 10px"
                                  }

                              ]

                          }
                      ]
                  });

                  formSettingsConfigureChildTermination.events.on("ButtonClick", function(id,e){
                      console.log("<b>onClick event Family</b> button("+id+") was clicked with "+formSettingsConfigureChildTermination.getValue()["Url"]);
                      let CssLink = formSettingsConfigureChildTermination.getValue()["CssLink"];
                      let MediaType = formSettingsConfigureChildTermination.getValue()["MediaType"];
                      let Template = formSettingsConfigureChildTermination.getValue()["Template"];
                      let Url = formSettingsConfigureChildTermination.getValue()["Url"];
                      let ComponentID = formSettingsConfigureChildTermination.getValue()["ChildComponentID"];
                      let ComponentDisplayName = formSettingsConfigureChildTermination.getValue()["ComponentDisplayName"];

                      if(id == "apply-button-configure-sub-remove-termination") {
                         terminationObj.Action = "Remove";
                      }

                      let Action = terminationObj.Action;

                      $.ajax({
                        type:"POST",
                        url:"/BotServices/bot/setChildTermination",
                        data: {"Action":Action,"DisplayName":ComponentDisplayName,"ComponentID":Component,"CssLink":CssLink,"MediaType":MediaType,"Template":Template,"URL":Url},
                        dataType:"json",
                        success: function(data) {
                            console.log("Got HTTP Response configure set child  termination");
                            console.log(data);
                          }
                        });
                    });

                });
            }
        });
   // });

    this.form.events.on("click", (id) => {
        console.log("Got id :"+id); 
        let newData = this.form.getValue();    
        console.log("got initial context",newData.initialContext);
        var client = window.botStore.getClientByViewPort(this.viewport); 
        let GrantPath = JSON.parse(client.CurrentContext);
        let GrantPE = GrantPath.GrantPE;
        //let InitialContext = document.getElementById('initialContext').value;
        let InitialContext  = {};
        let LocationContext = JSON.parse(client.LocationContext);
        console.log("location context",LocationContext);
        let signedURL = LocationContext.origin + '/DeviceManager/index.html';
        console.log("location context signedurl",signedURL);
        //let signedURL = '/DeviceManager/index.html';
        if(newData.onLoadComponent == "Alert") {
            this.ribbon.show("configure_alert");
        } else {
            this.ribbon.hide("configure_alert");
        }
        $.ajax({
        type:"POST",
        url:"/BotServices/bot/getSignedUrl",
        data: JSON.stringify({"Role":'visitor',"Component":client.ClientRight,"TTL":newData.TTL,"Username":newData.username,"openFlag":newData.openFlag,"onLoadComponent":newData.onLoadComponent,"URL":signedURL,"InitialContext":InitialContext,"Name":newData.deeplinkcustomname}),
        dataType:"json",
        contentType:"application/json",
        success: function(res) {
             console.log("Got HTTP Response signedurl");
             console.log(res);
             document.getElementById("deeplinkdiv").style.display = "";
             document.getElementById("meetshorturllink").innerHTML= res.ShortURL; 
             console.log("meet short url",document.getElementById("meetshorturllink").innerHTML,"==",res.ShortURL);  
            }
        });
        //window.DevMgr.setMeeting(document.getElementById('initialContext').value);
        //this.DeepLinkpopupshow = false;
    });

    },
    copyToClipboard :  function() {
        var copyText = document.getElementById("meetshorturllink").innerHTML;
        navigator.clipboard.writeText(copyText);

        var tooltip = document.getElementById("myTooltip");
        tooltip.innerHTML = "Copied: " + copyText;
    },
    outFunc : function () {
        var tooltip = document.getElementById("myTooltip");
        tooltip.innerHTML = "Copy to clipboard";
    },
    showRibbon: function () {
        this.config = [
            {
            "type": "block",
            "id": "dialeractions",
            "items": [
                {
                    type: "block",
                    items:[
                            {
                                value: "Termination",
                                tooltip: "Configure Termination URL",
                                icon: "far fa-plus action-blue",
                                id:"configure_termination",
                                view: "link",
                                size: "small",
                                color: "primary",
                                padding: "8px",
                                twoState: true
                            },
                            {
                                value: "Child Termination",
                                tooltip: "Configure Child Termination",
                                icon: "far fa-sync-alt  action-green",
                                id:"configure_child_termination"
                            },
                            {
                                value: "Alert",
                                tooltip: "Configure Alert",
                                icon: "fal fa-external-link  action-blue",
                                id: "configure_alert"  
                            },
                            {
                                value: "Sharing Link",
                                tooltip: "Create Sharing Link",
                                icon: "fal fa-external-link  action-blue",
                                id: "create_sharing_link"  
                            },
                    ]
                }
            ]
            },
            {
                    "id": "callactions",
                    "type": "block",
                    "items": [
                        {
                            "type": "block",
                            "items": []
                        },
                    ]
                }

        ];

        this.ribbon.data.add(this.config);

        const parent = this.ribbon.data.getParent("dialeractions");
        this.ribbon.data.add({ type: "spacer" }, this.ribbon.data.getIndex("dialeractions") + 1, parent);
        this.ribbon.hide("configure_alert");        
        this.ribbon.select("configure_termination");  

        this.ribbon.events.on("click",(event)=> {
            console.log("ribbon click event got:",event);
            if(event == "configure_termination") {
                document.getElementById('publishingformid').style.display = 'none';
                document.getElementById('form-settings-get-termination').style.display = 'none';
                document.getElementById('form-settings-configure-termination').style.display = '';
                document.getElementById('form-settings-get-child-termination').style.display = 'none';
                document.getElementById('form-settings-configure-sub-termination').style.display = 'none';
                document.getElementById('form-settings-configure-child-termination').style.display = 'none';
                document.getElementById('form-configure-alert').style.display = 'none';
                this.ribbon.select("configure_termination");
            } else if(event == "configure_child_termination") {
                document.getElementById('publishingformid').style.display = 'none';
                document.getElementById('form-settings-get-termination').style.display = 'none';
                document.getElementById('form-settings-configure-termination').style.display = 'none';
                document.getElementById('form-settings-get-child-termination').style.display = 'none';
                document.getElementById('form-settings-configure-sub-termination').style.display = '';
                document.getElementById('form-settings-configure-child-termination').style.display = 'none';
                document.getElementById('form-configure-alert').style.display = 'none';
                this.ribbon.select("configure_child_termination");
            } else if(event == "configure_alert") {
                document.getElementById('publishingformid').style.display = 'none';
                document.getElementById('form-settings-get-termination').style.display = 'none';
                document.getElementById('form-settings-configure-termination').style.display = 'none';
                document.getElementById('form-settings-get-child-termination').style.display = 'none';
                document.getElementById('form-settings-configure-sub-termination').style.display = 'none';
                document.getElementById('form-settings-configure-child-termination').style.display = 'none';
                document.getElementById('form-configure-alert').style.display = '';
                this.ribbon.select("configure_alert");
            } else if(event == "create_sharing_link") {
                document.getElementById('publishingformid').style.display = '';
                document.getElementById('form-settings-get-termination').style.display = 'none';
                document.getElementById('form-settings-configure-termination').style.display = 'none';
                document.getElementById('form-settings-get-child-termination').style.display = 'none';
                document.getElementById('form-settings-configure-sub-termination').style.display = 'none';
                document.getElementById('form-settings-configure-child-termination').style.display = 'none';
                document.getElementById('form-configure-alert').style.display = 'none';
                this.ribbon.select("create_sharing_link");
            } else {
                document.getElementById('publishingformid').style.display = 'none';
                document.getElementById('form-settings-get-termination').style.display = 'none';
                document.getElementById('form-settings-configure-termination').style.display = '';
                document.getElementById('form-settings-get-child-termination').style.display = 'none';
                document.getElementById('form-settings-configure-sub-termination').style.display = 'none';
                document.getElementById('form-settings-configure-child-termination').style.display = 'none';
                document.getElementById('form-configure-alert').style.display = 'none';
                this.ribbon.select("configure_termination");
            }
        });
    }
  }
}
</script>

<template>
<v-button style="display:none;" @click="show = true">Open modal</v-button>
<Popup v-model="publishingpopupshow" >
  <template v-slot:title>Publishing  Link</template>
  <template v-slot:content>
    <div ref="publishingribbon"></div>
    <div ref="publishingform" id="publishingformid" style="display: none;"></div>
    <div id="deeplinkdiv" style="display: none;"><span class="label-text" id="meetshorturllink"></span>&nbsp;&nbsp;<div class="tooltip"><span class="far fa-copy" @click="copyToClipboard" @onmouseout="outFunc" style="color:#0072c5;cursor:pointer;"></span><span class="tooltiptext" id="myTooltip">Copy to clipboard</span></div></div>
    <div id="form-settings-get-termination" style="display: none;"></div>
    <div id="form-settings-configure-termination" style="display: '';"></div>
    <div id="form-settings-get-child-termination" style="display: none;"></div>
    <div id="form-settings-configure-sub-termination" style="display: none;"></div>
    <div id="form-settings-configure-child-termination" style="display: none;"></div>
    <div id="form-configure-alert" style="display: none;"></div>
    
    <form class="formbox" style="display:none;">
    <div class="form-group" style="display:flex;">
      <span class="label-text">Context</span>
      <input type="text" name="initialContext" id="initialContext" class="input-text" v-model="initialContext"/>
    </div>
    <div class="form-group" style="display:flex;">
      <span class="label-text">Output</span>
      <input type="text" name="output-signedurl" id="output-signedurl" class="input-text" />
    </div>    
  </form>
  </template>
</Popup>
</template>

<style>
.label-text {
    padding: 0 50px;
    font-size: inherit;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    white-space: nowrap;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}
.input-text {
  background-color: white;
  border: 1px solid lightgray;
  width: 100%;
  display: block;
}
.ButtonText{
    margin-left: 145px;
    height: 25px;
    background-color: #0072c5;
    color: #fff;
    white-space: nowrap;
    align-items: center;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
    width:100%;
}

formbox{
  max-width:460px;
  margin:auto;
  margin-top:35px;
  border:0px solid #2f2f2f;
  padding:24px;
  border-radius:4px;
}
#btn-submit{
  width:100%;
}
.dhx_layout-cell-header {
background-color: #0072c5;

}
</style>
